import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5981cf29"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "gn-input__icon absolute inset-y-0 left-0 flex items-center pl-3" }
const _hoisted_4 = ["name", "id", "modelValue", "aria-invalid", "aria-describedby"]
const _hoisted_5 = {
  key: 0,
  class: "gn-input__error-icon"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenproxError = _resolveComponent("GenproxError")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.testId,
    class: _normalizeClass(['gn-input', _ctx.hasError ? 'error' : ''])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: "gn-input__label label"
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['relative rounded-md shadow-sm', _ctx.label ? 'mt-2' : ''])
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), { class: "w-5 h-5 text-gray-600" }))
      ]),
      _createElementVNode("input", _mergeProps({..._ctx.inputAttrs}, {
        class: ['gn-input__field', _ctx.icon ? 'has-icon' : ''],
        name: _ctx.id,
        id: _ctx.id,
        modelValue: _ctx.value,
        "aria-invalid": _ctx.hasError ? 'true' : 'false',
        "aria-describedby": `${_ctx.id}-error`,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleInput($event, $event.target.value))),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
      }), null, 16, _hoisted_4),
      (_ctx.hasError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_GenproxError, {
      validation: _ctx.validation,
      id: `${_ctx.id}-error`
    }, null, 8, ["validation", "id"])
  ], 10, _hoisted_1))
}